const secondaryMenu = document.querySelector('.nav-secondary-desktop');
const btns = secondaryMenu?.querySelectorAll('.button');
const searchInput = secondaryMenu?.querySelector('.search-panel-input');

function btnsCollapse() {
    btns.forEach((btn) => {
        const btnText = btn.querySelector('span');
        btnText?.classList.add('visuallyhidden');
    });
}

function btnsExpand() {
    btns.forEach((btn) => {
        const btnText = btn.querySelector('span');
        btnText?.classList.remove('visuallyhidden');
    });
}

function searchInputCollapse() {
    searchInput?.classList.add('visuallyhidden');
}

function searchInputExpand() {
    searchInput?.classList.remove('visuallyhidden');
}

function handleViewportChange() {
    if (window.innerWidth < 1715) {
        btnsCollapse();
    } else {
        btnsExpand();
    }

    if (window.innerWidth < 1440) {
        searchInputCollapse();
    } else {
        searchInputExpand();
    }
}

window.addEventListener('resize', handleViewportChange);
handleViewportChange();
